import ApiService from '@/services/api';
import moment from 'moment';
import { Storage } from 'aws-amplify';

const API = new ApiService();

export const state = {
  paymentMethodList: [],
  walletSkus: [],
  walletBalance: 0,
  holdBalance: 0
}

export const mutations = {
  SET_PAYMENT_METHODS(state, paymentMethodList) {
    state.paymentMethodList = paymentMethodList;
  },
  SET_SKUS(state, walletSkus) {
    state.walletSkus = walletSkus;
  },
  SET_WALLET_BALANCE(state, walletBalance) {
    state.walletBalance = walletBalance;
  },
  SET_HOLD_BALANCE(state, holdBalance) {
    state.holdBalance = holdBalance;
  }
}

export const getters = {
}

export const actions = {
  // eslint-disable-next-line no-unused-vars
  fetchPaymentMethods({ commit }) {
    return new Promise((resolve, reject) => {
      API.get('/wallet/payment-methods', { module: 'kanto_ads' })
        .then(res => {
          console.log(res.message);
          commit('SET_PAYMENT_METHODS', res.message);
          resolve(res)
        })
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  fetchWalletSkus({ commit }) {
    return new Promise((resolve, reject) => {
      API.get('/wallet/skus')
        .then(res => {
          console.log(res.message)
          commit('SET_SKUS', res.message);
          resolve(res)
        })
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  paymodeOne({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/wallet/pay-mode-one', params)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  paymodeTwo({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/wallet/pay-mode-two', params)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  modeOneStatus({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.get('/wallet/mode-one-status', params)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  modeTwoStatus({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.get('/wallet/mode-two-status', params)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  fetchWalletBalance({ commit }) {
    return new Promise((resolve, reject) => {
      API.get('/wallet/balance')
        .then(res => {
          console.log(res);
          commit('SET_WALLET_BALANCE', res.message.balance)
          resolve(res)
        })
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  fetchHoldBalance({ commit }) {
    return new Promise((resolve, reject) => {
      API.get('/wallet/hold-balance')
        .then(res => {
          console.log(res);
          commit('SET_HOLD_BALANCE', res.message.balance)
          resolve(res)
        })
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  createBankTransfer({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post('/wallet/create-transfer', params)
        .then(res => {
          console.log(res);
          resolve(res)
        })
        .catch(err => reject(err));
    });
  },
  // eslint-disable-next-line no-unused-vars
  uploadProofOfPayment({ commit }, params) {
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg", "jpeg", "png"];
      if (params.type && !allowedType.includes(params.type.toLowerCase())) {
        reject("Filetype not allowed");
        return;
      }

      var metadata = {
        level: 'public',
        expires: moment().add(365, 'days').toDate(),
      }

      if (params.type == 'svg') {
        metadata['contentType'] = 'image/svg+xml';
      }

      Storage.put(`proof-of-payment/${params.filename}`, params.base64, metadata)
        .then(stored => {
          console.log(stored);
          resolve(stored.key);
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    });
  },
}